/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
    'emoji-sunglasses': {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: '<path pid="0" d="M4.968 9.75a.5.5 0 10-.866.5A4.5 4.5 0 008 12.5a4.5 4.5 0 003.898-2.25.5.5 0 10-.866-.5A3.5 3.5 0 018 11.5a3.5 3.5 0 01-3.032-1.75M7 5.116V5a1 1 0 00-1-1H3.28a1 1 0 00-.97 1.243l.311 1.242A2 2 0 004.561 8H5a2 2 0 001.994-1.839A3 3 0 018 6c.393 0 .74.064 1.006.161A2 2 0 0011 8h.438a2 2 0 001.94-1.515l.311-1.242A1 1 0 0012.72 4H10a1 1 0 00-1 1v.116A4.2 4.2 0 008 5c-.35 0-.69.04-1 .116"/><path pid="1" d="M16 8A8 8 0 110 8a8 8 0 0116 0m-1 0A7 7 0 101 8a7 7 0 0014 0"/>',
    },
});
